import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
//import Drawer from './Drawer';
import Header from './Header';

const MainLayout = () => {
  const theme = useTheme();
  const matchDownLG = useMediaQuery(theme.breakpoints.down('xl'));
  const [open, setOpen] = useState(false);
  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  // set media wise responsive drawer
  useEffect(() => {
    setOpen(!matchDownLG);
  }, [matchDownLG]);

  useEffect(() => {
    if (open !== open) setOpen(open);
  }, [open]);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
        <Header />
        {/**
        <Header open={open} handleDrawerToggle={handleDrawerToggle} />
        <Drawer open={open} handleDrawerToggle={handleDrawerToggle} />
        **/}
      <Box
        component='main'
        sx={{ width: '100%', flexGrow: 1, p: { xs: 2, sm: 3 } }}
      >
        {/* <Toolbar /> */}
        {/* <Breadcrumbs
          navigation={navigation}
          title
          titleBottom
          card={false}
          divider={false}
        /> */}
        <Box style={{ marginTop: '40px' }}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout;
